import client from './inventory-request';
import { mapMedicineSearchRows } from '../utils/medicineSearch';

// Categories — all calls via EMR proxy (/app/api/inventory/...), not direct /api/v1 (CORS).
// API: GET /inventory/categories/
export const getCategories  = (p) => client.get('/inventory/categories/', p);
// API: GET /inventory/categories/{id}/
export const getCategory    = (id) => client.get(`/inventory/categories/${id}/`);
// API: POST /inventory/categories/
export const createCategory = (body) => client.post('/inventory/categories/', body);
// API: PATCH /inventory/categories/{id}/
export const updateCategory = (id, body) => client.patch(`/inventory/categories/${id}/`, body);
// API: DELETE /inventory/categories/{id}/
export const deleteCategory = (id) => client.delete(`/inventory/categories/${id}/`);

// UOMs
// API: GET /inventory/uoms/
export const getUoms   = (p) => client.get('/inventory/uoms/', p);
// API: GET /inventory/uoms/{id}/
export const getUom    = (id) => client.get(`/inventory/uoms/${id}/`);
// API: POST /inventory/uoms/
export const createUom = (body) => client.post('/inventory/uoms/', body);
// API: PATCH /inventory/uoms/{id}/
export const updateUom = (id, body) => client.patch(`/inventory/uoms/${id}/`, body);
// API: DELETE /inventory/uoms/{id}/
export const deleteUom = (id) => client.delete(`/inventory/uoms/${id}/`);

// Items
// API: GET /inventory/items/
export const getItems                 = (p) => client.get('/inventory/items/', p);
// API: GET /inventory/items/{id}/
export const getItem                  = (id) => client.get(`/inventory/items/${id}/`);
// API: POST /inventory/items/
export const createItem               = (body) => client.post('/inventory/items/', body);
// API: PATCH /inventory/items/{id}/
export const updateItem               = (id, body) => client.patch(`/inventory/items/${id}/`, body);
// API: DELETE /inventory/items/{id}/
export const deleteItem               = (id) => client.delete(`/inventory/items/${id}/`);
// API: GET /inventory/items/by-code/{code}/
export const getItemByCode            = (code) => client.get(`/inventory/items/by-code/${code}/`);
// API: GET /inventory/items/{id}/rules/
export const getItemValidationProfile = (id) => client.get(`/inventory/items/${id}/rules/`);

// EMR formulary typeahead — GET /search_medicines/?name=
export async function searchMedicines(name) {
  const q = (name || '').trim();
  if (q.length < 2) return [];
  const rows = await client.get('/search_medicines/', { name: q });
  return mapMedicineSearchRows(rows);
}

// Stores — see api/stores.js (proxied /app/api/inventory/stores/)
export {
  getStores, getStore, createStore, updateStore, deleteStore,
} from './stores';
